import {
  CLIENTS_GET_REQUEST,
  CLIENTS_GET_SUCCESS,
  CLIENTS_GET_FAILURE,
  AGENT_CLIENTS_GET_REQUEST,
  AGENT_CLIENTS_GET_SUCCESS,
  AGENT_CLIENTS_GET_FAILURE
} from "../actions";

export default function clients(state = {
  loading: false, count: 0, perPage: 25, page: 0,
  pagination: { pageSize: 25, total: 0, showSizeChanger: true, showQuickJumper: true, pageSizeOptions: ['25', '50', '100'] }, data: [{}], sorted: undefined
}, action) {
  switch (action.type) {
    case CLIENTS_GET_REQUEST:
    case AGENT_CLIENTS_GET_REQUEST:
      return {
        ...state,
        loading: true
      };
    case CLIENTS_GET_SUCCESS:
    case AGENT_CLIENTS_GET_SUCCESS:
      return { loading: false, ...action.data };
    case CLIENTS_GET_FAILURE:
    case AGENT_CLIENTS_GET_FAILURE:
      return { loading: false, error: action.error };
    default:
      return state;
  }
}
